import { useSearchParams } from "react-router-dom";

export function useQuoteId() {
  const [searchParams] = useSearchParams();
  const quoteId = searchParams.get("quoteId") ?? searchParams.get("QuoteId");

  return { quoteId: quoteId ?? null };
}
